import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Button
} from 'semantic-ui-react'

const CardHealthRecommendationUX = (props: any) => {
    return(
      <div
        id="CardHealthRecommendationUX-div-0"
        style={{position: "relative", padding: "1em", width: "100%", height: "100%"}}>
        <div
          id="CardHealthRecommendationUX-div-1">
          
          <Form
            id="CardHealthRecommendationUX-Form-3">
            <FormGroup
              id="CardHealthRecommendationUX-FormGroup-4"
              inline={true}>
              <FormField
                id="CardHealthRecommendationUX-FormField-5"
                inline={true}
                style={{display: "flex", alignItems: "center"}}>
                <label
                  id="CardHealthRecommendationUX-label-6"
                  style={{fontSize: "18px"}}>
                  Medical Report
                </label>
                <Dropdown
                  disabled={props.isDisabled}
                  fluid={true}
                  id="CardHealthRecommendationUX-Dropdown-7"
                  name="language"
                  onChange={props.onChangeData}
                  options={props.languageOptions}
                  selection={true}
                  value={props.data?.language || ""}>
                </Dropdown>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardHealthRecommendationUX-div-8"
          style={{display: "grid", width: "100%", height: "calc(90vh - 5rem)", gridTemplateRows: "repeat(1, 1fr)", gridTemplateColumns: "repeat(3, 1fr)"}}>
          
          <div
            id="CardHealthRecommendationUX-div-9"
            style={{gridRow: "1/1", gridColumn: "1/3", paddingRight: "1rem"}}>
            
            <div
              id="CardHealthRecommendationUX-div-28"
              style={{display: "flex", justifyContent: "space-between", paddingBottom: "1rem"}}>
              
              <div
                id="CardHealthRecommendationUX-div-40"
                style={{display: "flex", alignItems: "center", gap: "0.5rem"}}>
                
                <label
                  id="CardHealthRecommendationUX-label-42"
                  style={{ fontWeight: "bold" }}>
                  Encounter
                </label>
                <Dropdown
                  id="CardHealthRecommendationUX-Dropdown-34"
                  name="encounter"
                  onChange={props.onChangeData}
                  options={props.encounterOptions}
                  placeholder="Select Encounter"
                  selection={true}
                  value={props.data?.encounter || ""}>
                </Dropdown>
              </div>
              <div
                id="CardHealthRecommendationUX-div-41"
                style={{display: "flex", justifyContent: "right", alignItems: "center", width: "60%"}}>
                
                <label
                  id="CardHealthRecommendationUX-label-43"
                  style={{fontWeight: "bold", paddingRight: "0.5rem"}}>
                  Checkup Report
                </label>
                <Dropdown
                  id="CardHealthRecommendationUX-Dropdown-30"
                  name="id"
                  onChange={props.onChangeData}
                  options={props.checkupReportOptions}
                  placeholder="Select Checkup Report"
                  selection={true}
                  style={{width: "75%"}}
                  value={props.data?.checkup_report_data?.id || ""}>
                </Dropdown>
              </div>
            </div>
            <div
              id="CardHealthRecommendationUX-div-29">
              {props.pdfPreview}
            </div>
          </div>
          <div
            id="CardHealthRecommendationUX-div-10"
            style={{ gridRow: "1/1", gridColumn: "3/4" }}>
            
            <div
              id="CardHealthRecommendationUX-div-31"
              style={{display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "1rem"}}>
              
              <label
                id="CardHealthRecommendationUX-label-32"
                style={{fontWeight: "bold"}}>
                Doctor's Recommendation
              </label>
              <Button
                color="blue"
                disabled={props.isDisabled}
                id="CardHealthRecommendationUX-Button-33"
                onClick={props.onOpenNoteTemplate}
                size="small">
                Note Template
              </Button>
            </div>
            <Form
              id="CardHealthRecommendationUX-Form-12">
              <FormGroup
                id="CardHealthRecommendationUX-FormGroup-14">
                <FormField
                  id="CardHealthRecommendationUX-FormField-17"
                  style={{width: "100%"}}>
                  <div
                    id="CardHealthRecommendationUX-div-39">
                    {props.doctorNoteTextEditor}
                  </div>
                </FormField>
              </FormGroup>
              <div
                id="CardHealthRecommendationUX-div-44">
                {props.renderActionButton}
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
}


export default CardHealthRecommendationUX

export const screenPropsDefault = {}

/* Date Time : Fri Oct 24 2025 03:33:36 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", padding: \"1em\", width: \"100%\", height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-Form-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Medical Report"
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-label-6"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"18px\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Dropdown",
      "parent": 5,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isDisabled"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-Dropdown-7"
        },
        "name": {
          "type": "value",
          "value": "language"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.languageOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.data?.language || \"\""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", width: \"100%\", height: \"calc(90vh - 5rem)\", gridTemplateRows: \"repeat(1, 1fr)\", gridTemplateColumns: \"repeat(3, 1fr)\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{gridRow: \"1/1\", gridColumn: \"1/3\", paddingRight: \"1rem\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/1\", gridColumn: \"3/4\" }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Form",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-Form-12"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormGroup",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-FormGroup-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-FormField-17"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", paddingBottom: \"1rem\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pdfPreview"
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-29"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Dropdown",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-Dropdown-30"
        },
        "name": {
          "type": "value",
          "value": "id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.checkupReportOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "Select Checkup Report"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"75%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.data?.checkup_report_data?.id || \"\""
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\", paddingBottom: \"1rem\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "Doctor's Recommendation"
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Button",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "Note Template"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.isDisabled"
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-Button-33"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenNoteTemplate"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Dropdown",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-Dropdown-34"
        },
        "name": {
          "type": "value",
          "value": "encounter"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.encounterOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "Select Encounter"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.data?.encounter || \"\""
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorNoteTextEditor"
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-39"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", gap: \"0.5rem\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"right\", alignItems: \"center\", width: \"60%\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "Encounter"
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-label-42"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "Checkup Report"
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-label-43"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", paddingRight: \"0.5rem\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderActionButton"
        },
        "id": {
          "type": "value",
          "value": "CardHealthRecommendationUX-div-44"
        }
      },
      "seq": 44,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardHealthRecommendationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
